<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="preface">
<p class="chapterTitle1">PREFACE</p>
<p class="centerImage1"><img alt="image" src="images/throut.jpg" style="max-height: 90%"/></p>
<p class="para">A sheriff’s deputy was cleaning out the basement of the Missoula County Courthouse one afternoon in the 1970s when he stumbled across a stack of wanted posters dating back to the early 1900s. </p>
<p class="para">The nearly 200 documents, some faded and torn, told stories of murder, theft, cheats, broken promises, and daring escapes.</p>
<p class="para">Intrigued, the deputy showed the posters to Missoula County Sheriff John C. Moe. Being a career lawman, the sheriff took an immediate interest in the newly found material.</p>
<p class="para">“I looked them over and decided they would be of interest to historians,” Moe said. “I looked them over and thought, ‘Well, I’ll put them together in a book.’”</p>
<p class="para">Moe donated the collection to the Historical Museum at Fort Missoula, in Montana, in 2003, and a selection of the documents is presented here. Sources of information for the introduction, chapter openings, and stories are listed in the bibliography.</p>
<p class="centerImage"><img alt="images" id="throut1" src="images/throut1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02b_preface.vue?45d2280a